import { render } from "./question-circle.vue?vue&type=template&id=8641b4c6"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/question-circle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8641b4c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8641b4c6', __exports__)) {
    api.reload('8641b4c6', __exports__)
  }
  
  module.hot.accept("./question-circle.vue?vue&type=template&id=8641b4c6", () => {
    api.rerender('8641b4c6', render)
  })

}


export default __exports__